import styled from 'styled-components';

export const DeclarationWrapper = styled.div`
  & + & {
    margin-top: 24px;
  }
`;
